import {isObject, isString} from 'lodash'

const trimFields = () => (next) => (action) => {
  if (isObject(action) && action.type === '@@redux-form/BLUR' && isString(action.payload)) {
    next({...action, payload: action.payload.trim()})
  } else {
    next(action)
  }
}

export default trimFields
